import { DOCUMENT, inject, Service } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Service()
export class FullScreenService {
  private document = inject<Document>(DOCUMENT);

  private readonly isFullScreenSubject = new BehaviorSubject(this.isFullscreen);

  public readonly isFullScreen$ = this.isFullScreenSubject.asObservable();

  public get isFullscreen(): boolean {
    return !!this.document.fullscreenElement;
  }

  constructor() {
    this.document.addEventListener('fullscreenchange', this.onFullScreenChange);

    this.onFullScreenChange();
  }

  public open(): void {
    this.document.documentElement.requestFullscreen();
  }

  public close(): void {
    this.document.exitFullscreen();
  }

  private onFullScreenChange = (): void => {
    this.isFullScreenSubject.next(this.isFullscreen);
  };
}
